import React, { useState } from "react";
import { Form, Grid, Alert } from "tabler-react";
import { Modal, Button } from "react-bootstrap";
import { formatNoCurrency } from "../../MoneyFormatter";
import useForm from "../../effects/useForm";
import { post } from "../../httpUtils";
import fetchEmployees from "../Employees/fetchEmployees";
import { useToasts } from "react-toast-notifications";
import Select from "react-dropdown-select";

const PayrollForm = (props) => {
  const { addToast } = useToasts();
  const [errors, setErrors] = useState([]);
  const { handleChange, handleSubmit, values, manualChange } = useForm(submit);
  const { results: employees } = fetchEmployees();

  async function submit(data) {
    //validate
    try {
      await post("/hrm/payroll", data);
      addToast("Payment Recorded Successfully", { appearance: "success" });
      props.onHide();
    } catch (e) {
      if (e.errors) {
        setErrors(e.errors);
      } else {
        setErrors(["An error occurred"]);
      }
    }
  }
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>Payroll</Modal.Title>
          <Button onClick={props.onHide} variant="outline-danger" size="sm">
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          {errors.map((error) => (
            <Alert type="danger">{error}</Alert>
          ))}
          <Form.FieldSet className="Payroll">
            <Grid>
              <Grid.Row>
                <Grid.Col width={6}>
                  <Form.Group label="Employee">
                    <Select
                      name="employee"
                      placeholder="Select employee"
                      searchBy="employee"
                      valueField="_id"
                      labelField="fullname"
                      options={employees}
                      onChange={(values) => {
                        if (values.length) {
                          manualChange({
                            name: "employee",
                            value: values[0]._id,
                          });
                        }
                      }}
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col width={6}>
                  <Form.Group label="Gross">
                    <Form.Input
                      name="gross"
                      type="number"
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col width={6}>
                  <Form.Group label="Tax">
                    <Form.Input
                      name="tax"
                      type="number"
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col width={6}>
                  {" "}
                  <Form.Group label="NSSF">
                    <Form.Input
                      name="nssf"
                      type="number"
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col width={6}>
                  <Form.Group label="Cash Advance">
                    <Form.Input
                      name="advance"
                      type="number"
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col width={6}>
                  {" "}
                  <Form.Group label="Deductions">
                    <Form.Input
                      name="deductions"
                      type="number"
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col width={12}>
                  <Form.Group label="Net pay">
                    <Form.Input
                      name="netPay"
                      onChange={handleChange}
                      disabled
                      value={formatNoCurrency(calculateNetPay(values))}
                    />
                  </Form.Group>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col width={6}></Grid.Col>

                <Grid.Col width={6}></Grid.Col>
              </Grid.Row>
            </Grid>
          </Form.FieldSet>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-danger" onClick={props.onHide}>
            <i class="fe fe-x mr-2"></i>Close
          </Button>
          <Button type="submit" variant="outline-success">
            <i class="fe fe-check mr-2"></i>Submit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

function calculateNetPay(values) {
  const gross = parseInt(values.gross || 0);
  const advance = parseInt(values.advance || 0);
  const deductions = parseInt(values.deductions || 0);
  const nssf = parseInt(values.nssf || 0);
  const tax = parseInt(values.tax || 0);
  const toRemove = advance + deductions + nssf + tax;
  console.log(toRemove);
  return gross - toRemove;
}
export default PayrollForm;
